import Loading from "components/Loading";
import Permission from "components/Permission";
import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import PermissionDeniedPage from "components/PermissionDenied";
import { MODULE_MERCHANT_UTILITY } from "shared/constants";

const MerchantUtility = React.lazy(
  () => import("containers/MerchantManagement/MerchantUtility")
);

const MerchantUtilityRoute = () => {
  return (
    <Route
      path="merchant-utility"
      element={
        <Suspense fallback={<Loading loading />}>
          <Permission
            children={<MerchantUtility />}
            permissionDenied={<PermissionDeniedPage />}
            modules={[MODULE_MERCHANT_UTILITY]}
          />
        </Suspense>
      }
    />
  );
};

export default MerchantUtilityRoute;
